// Layout-маршрут для /settings/* — оборачивает все sub-routes в SettingsShell.
// См. docs/ui-spec/settings._layout.{desktop,mobile}.md.
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SettingsShell } from "@/components/settings/settings-shell";

export const Route = createFileRoute("/settings")({
	component: SettingsLayoutRoute,
});

function SettingsLayoutRoute() {
	return (
		<SettingsShell>
			<Outlet />
		</SettingsShell>
	);
}
